import { Button } from './button.model';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export enum PriceCardColor {
  ORANGE = 'orange',
  GREEN = 'green',
  BLUE = 'blue',
}

export interface PriceCardInfo {
  title: string;
  subtitle: string;
  extra?: string;
}

export interface PriceCard {
  title: string;
  iconName?: IconProp;
  info: PriceCardInfo;
  text: string;
  buttons: Button[];
  color: PriceCardColor;
}
